import { get, reduce } from 'lodash';
import ParkingTypes from './parkingTypes';

const parkingInitialValues = (state) => {
  const isAvailable = get(state, 'space.data.parking_info.is_available', true);
  const description = get(state, 'space.data.parking_info.description', '');
  const types = get(state, 'space.data.parking_info.types', '');
  const initalTypesValues = reduce(ParkingTypes, (result, value) => {
    if (-1 !== types.indexOf(value.key)) {
      result.push(value.key);
    } else {
      result.push(null);
    }
    return result;
  }, []);

  return {
    is_available: isAvailable.toString(),
    description,
    types: initalTypesValues
  };
};

export default parkingInitialValues;
